import { Directive, HostListener, input } from '@angular/core';

@Directive({
  selector: '[vectronicAllowedPattern]',
})
export class AllowedPatternDirective {
  /**
   * @description a string-regex describing what chars are allowed. Special keys for navigation as well as their combination with letters to copy, select all or paste are allowed though
   * @example to allow only numbers use '[0-9]'
   */
  vectronicAllowedPattern = input.required<RegExp, string>({
    transform: (pattern) => new RegExp(pattern),
  });

  @HostListener('keydown', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const inputChar = event.key;

    // Allow navigation keys (arrows), backspace, delete, tab, escape, enter, end and home
    if (
      [
        'ArrowLeft',
        'ArrowRight',
        'ArrowUp',
        'ArrowDown',
        'Backspace',
        'Delete',
        'Tab',
        'Escape',
        'Enter',
        'End',
        'Home',
      ].includes(event.key)
    ) {
      return;
    }

    // Allow copy (Ctrl+C), cut (Ctrl+X), paste (Ctrl+V), select all (Ctrl+A) and undo (Ctrl+Z)
    if (
      (event.ctrlKey || event.metaKey) &&
      ['c', 'x', 'v', 'a', 'z'].indexOf(event.key.toLowerCase()) > -1
    ) {
      return;
    }

    if (!this.vectronicAllowedPattern().test(inputChar)) {
      event.preventDefault();
    }
  }
}
